var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Frame 5",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "svg-fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.9 21.49-3.87-6.72a.7.7 0 0 0-1.22 0l-3.88 6.72a.7.7 0 0 0 .61 1.05h7.76a.7.7 0 0 0 .6-1.05Zm-8.36.35 3.88-6.72 3.88 6.72h-7.76Z",
    fill: "#605E5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.93 17.54.2 2.31a.29.29 0 0 0 .57 0l.2-2.3v-.1a.49.49 0 0 0-.97.1ZM17.42 21.06a.4.4 0 1 0 0-.8.4.4 0 0 0 0 .8Z",
    fill: "#605E5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9 9.93c0 .55-.13 1-.3 1H5.28c-.16 0-.3-.45-.3-1s.14-1 .3-1h9.34c.16 0 .3.45.3 1ZM14.9 6.95c0 .55-.13 1-.3 1H5.28c-.16 0-.3-.45-.3-1 0-.54.14-.99.3-.99h9.34c.16 0 .3.45.3 1ZM14.9 12.9c0 .56-.13 1-.3 1H5.28c-.16 0-.3-.44-.3-1 0-.54.14-.98.3-.98h9.34c.16 0 .3.44.3.99ZM9.67 14.9H5.24c-.14 0-.26.44-.26.98 0 .55.12 1 .26 1h4.43c.15 0 .27-.45.27-1 0-.54-.12-.99-.27-.99Z",
    fill: "#605E5C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "svg-stroke"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.88 13.9V2.1c0-.6-.53-1.1-1.18-1.1H3.18C2.53 1 2 1.5 2 2.1v17.64c0 .61.53 1.1 1.18 1.1h9.24",
    stroke: "#605E5C",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame5);
export default __webpack_public_path__ + "static/media/Frame 5.f4fc86eae5b4f3de5c9dacccad0b0157.svg";
export { ForwardRef as ReactComponent };